// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SubscribedPhotoblogs":"tk_a bhv_b bhv_bj","SubscribedPhotoblogs__link":"tk_b bhv_a bhv_r"};